import { IconButton, Snackbar } from '@volvo/vcdk-react';
import { FunctionComponent } from 'react';
import { NotificationItem, removeMessage, selectMessages } from '../store/NotificationSlice';
import { useAppSelector } from '../../../store/Hooks';
import { useDispatch } from 'react-redux';
import "./NotificationsContainer.scss";

export const NotificationsContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const messages = useAppSelector(selectMessages);

  const onClickCloseNotification = (message: NotificationItem) => {
    dispatch(removeMessage(message))
  };

  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (messages.length === 0) { return <></>; }

  return (
    <Snackbar open={true} variant={messages[0].variant}>
      <div className="notifications-container">
        {messages[0].message}
        <IconButton icon="close" onClick={() => onClickCloseNotification(messages[0])} />
      </div>
    </Snackbar>
  );
};
